<template>
    <div v-if="!isClose"
        class="alert" 
        :class="[ 'alert-'+variant, 'alert-'+dismissible, {'fade':fade}, {'show':show}]"
        role="alert"
    >
    <slot/>
    <button @click="handleClick" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
</template>
<script>
export default {
    props:{
        variant: {
            type: String,
            default: 'primary'
        },
        dismissible: {
            type: String,
            default: 'dismissible'
        },
        fade: {
            type: Boolean,
            default: true
        },
        show: {
            type: Boolean, 
            defualt: true
        }

    },
    data:function(){
        return{
            isClose : false,
        }
    },
    name:"OAlert",
    methods: {
        handleClick:function(){
            this.isClose = true;
        },
    },
}
</script>